import { Box, Container } from "@mui/material";


const GTDescription = () => {

    return (
        <Container>
            <Box>
                ■ 認知特性テスト-解説-
                <Box marginLeft={1}>
                    <Box marginTop={3}>
                        <Box>このテストは、現時点での特性を把握するためのものです。</Box>
                        <Box>特性は後天的に伸ばしていくことが可能ですので、深く考えすぎず、</Box>
                        <Box>問題文から「これだ」と思う選択肢をお選びください。	</Box>
                    </Box>
                    <Box marginTop={2}>
                        <Box>テスト結果を基に、特性に応じた技術指導や会話を行うことで、</Box>
                        <Box>より理解しやすい研修やサポートを提供できます。</Box>
                    </Box>
                    <Box marginTop={2}>
                        <Box sx={{fontWeight: 'bold'}}>テストの実施方法</Box>
                        <Box marginTop={2} marginLeft={1}>右サイドメニューから認知特性テスト-問題-を選択してください。</Box>
                    </Box>
                    <Box marginTop={2}>
                        <Box sx={{fontWeight: 'bold'}}>テスト完了後の手順</Box>
                        <Box marginTop={2} marginLeft={1}>
                            <Box>1. テスト結果をCSV形式でダウンロードしてください。</Box>
                            <Box sx={{fontWeight: 'bold'}}>2. 企業研修を実施される方</Box>
                            <Box>ダウンロードしたCSVファイルを担当者へご提出ください。</Box>
                            <Box sx={{fontWeight: 'bold'}}>3. 弊社の求人にご応募の方</Box>
                            <Box>採用面接時に結果をお持ちいただき、ご提示ください。</Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Container>
    )
}

export default GTDescription;